import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSamsungComponent } from './simple-icons-samsung.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSamsungComponent ],
    exports:      [ SimpleIconsSamsungComponent ],
    bootstrap:    []
})
export class SimpleIconsSamsungModule {}
